import Vue from 'vue';

// convert Arabic Numbers To Hindi Number
Vue.directive('hindi-numbers', {
  inserted: (elem) => {
    // hindi Unique Code Character Map Found @ [ https://unicode-table.com ]
    const charMap = [
      '&#1632;',
      '&#1633;',
      '&#1634;',
      '&#1635;',
      '&#1636;',
      '&#1637;',
      '&#1638;',
      '&#1639;',
      '&#1640;',
      '&#1641;',
    ];
    elem.innerHTML = elem.innerHTML.replace(/\d(?=[^<>]*(<|$))/g, ($0) => {
      return '<span class="hindi-numbers">' + charMap[$0] + '</span>';
    });
  },
});
